// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--3a6YL","opaque":"header-module--opaque--slnh8"};